<script>
import locator from '@/service-locator'

export default {
  name: 'ZendeskChatbotButton',
  methods: {
    onShowZEChatBot() {
      locator.chatbot.openChatbot()
    },
  },
}
</script>

<template>
  <div class="zendesk-custom-launcher" @click="onShowZEChatBot">
    <svg viewBox="10 6 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="DialogueNew" fill="currentColor">
        <path
          d="M29.9996 39.3369H29.9996C28.9494 39.3228 27.9027 39.2117 26.873 39.0048C26.3867 38.9217 25.8882 39.0509 25.5034 39.3597C23.5353 40.8057 21.2244 41.714 18.7985 41.9951C18.3992 42.037 18.0415 41.7472 17.9997 41.3478C17.9817 41.1769 18.0249 41.0053 18.1214 40.8632H18.1214C19.059 39.6954 19.7322 38.3381 20.0947 36.885C20.1678 36.4882 20.0128 36.0839 19.6931 35.8378C16.1547 33.2089 14.0485 29.0767 14 24.6684C14 16.5773 21.1633 10 29.9996 10C38.8359 10 45.9992 16.5773 45.9992 24.6684C45.9992 32.7596 38.8361 39.3369 29.9996 39.3369H29.9996Z"
        />
      </g>
    </svg>
    <span>Chat with us - تواصل معنا</span>
  </div>
</template>

<style>
/* Add custom CSS to style the launcher */
.zendesk-custom-launcher {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 400;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  min-width: 95px;
  height: 44px;
  padding: 0 13px;
  overflow: hidden;
  color: rgb(0, 0, 0);
  cursor: pointer;
  background-color: rgb(255, 217, 183);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 42px;
  box-shadow: 0 4px 20px 4px rgba(0, 0, 0, 0.12);
  transition: 200ms opacity ease;
  animation: button-fade-in 200ms ease 0s;
  direction: ltr;
}

.zendesk-custom-launcher span {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: inherit;
  -webkit-font-smoothing: antialiased;
}

.zendesk-custom-launcher svg {
  top: -1px;
  width: 22px;
  height: 22px;
  padding: 0;
}

[dir='rtl'] {
  .zendesk-custom-launcher {
    right: unset;
    left: 24px;
  }

  iframe[name='نافذة المراسلة'] {
    right: unset !important;
    left: 24px !important;
  }
}
</style>
